import React, { FunctionComponent } from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import SearchPage from "../../pages/Search";
import CarPage from "../../pages/Car";
import GlobalStyles from "../../styles/GlobalStyles";
import { Settings } from "../../context/SettingsContext/SettingsContext";
import SettingsContext from "../../context/SettingsContext";

interface ApplicationSettings {
  settings: Settings;
}

const Search: FunctionComponent<ApplicationSettings> = ({ settings }) => {
  return (
    <div>
      <SettingsContext.Provider value={settings}>
        <GlobalStyles />
        <BrowserRouter>
          <Switch>
            <Route path="/search">
              <SearchPage settings={settings} />
            </Route>
            <Route path="/car">
              <CarPage settings={settings} />
            </Route>
          </Switch>
        </BrowserRouter>
      </SettingsContext.Provider>
    </div>
  );
};

export default Search;
